import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'

const StyledTextButton = styled.button`
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${colours.purpleButtonTextHover};
  }
  color: ${colours.purpleButtonText};
  transition: color 0.35s ease;
`

const StyledPrimaryTextButton = styled.button`
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${colours.aquaDarker};
  }
  color: ${colours.aqua};
  transition: color 0.35s ease;
`

interface IProps {
  onClick: any
  children: any
  primary?: boolean
  disabled?: boolean
  style?: any
}

class TextButton extends React.Component<IProps> {
  static defaultProps: { primary: boolean }

  render() {
    const { onClick, children, primary, disabled, style } = this.props
    const Component = disabled || !primary ? StyledTextButton : StyledPrimaryTextButton
    return (
      <Component onClick={onClick} disabled={!!disabled} style={style ? style : {}} className="btn">
        {children}
      </Component>
    )
  }
}

TextButton.defaultProps = {
  primary: false
}

export default TextButton
